import { MutableTypedObject } from "@multiweb/types/react";
import { UiWorkflow } from "./UiWorkflow";

export class WorkflowManager {
    /** Slouží k ukládání workflow objektů pro všechny instance editoru workflow  */
    public static uiWorkflows: MutableTypedObject<UiWorkflow> = {};
}
